import { render, staticRenderFns } from "./StudentArchives.vue?vue&type=template&id=5c24f4c0&scoped=true&"
import script from "./StudentArchives.vue?vue&type=script&lang=js&"
export * from "./StudentArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c24f4c0",
  null
  
)

export default component.exports